import { ticketServiceApi } from "../../../../app/superAdmin/ticketServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../../types";
import {
  AllProductsParams,
  AllProductsResponse,
  ProductDetailsResponse,
} from "./product.types";

export const productApi = ticketServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // Queries
    getAllProducts: builder.query<
      AllProductsResponse,
      GetQueryArgsType<AllProductsParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllProduct,
        ...queryArgs,
      }),
      providesTags: ["GetAllProducts"],
    }),

    getProductDetails: builder.query<ProductDetailsResponse, any>({
      query: (id) => ({
        url: `${API_URL.getProductDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetAllProducts", id }],
    }),

    // Mutations
    createProduct: builder.mutation({
      query: (data) => ({
        url: API_URL.createProduct,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAllProducts"],
    }),

    updateProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateProduct}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        return [
          "GetAllProducts",
          { type: "GetAllProducts", id: result?.data?.id },
        ];
      },
    }),

    updateProductStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateProductStatus}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        return [
          "GetAllProducts",
          { type: "GetAllProducts", id: result?.data?.id },
        ];
      },
    }),

    // deleteProduct: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `${API_URL.deleteTicket}/${id}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["GetAllProducts"],
    // }),
  }),
});

export const {
  useGetAllProductsQuery,
  useGetProductDetailsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useUpdateProductStatusMutation,
} = productApi;
